//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RepeatDetailsItem } from './RepeatDetailsItem';
import { InvoiceMode, InvoiceFormat } from './Enums';

export class AutoInvoiceDisplayItem extends ItemBase {
    NextInvoiceDate: string = "1970-01-01T00:00:00";
    InvoiceStartDate: string = "1970-01-01T00:00:00";
    InvoiceEndDate: string = "1970-01-01T00:00:00";
    NextInvoiceBillPeriod: string = "1970-01-01T00:00:00";
    DueDate: string | null = null;
    AutoEmail: boolean = false;
    InvoiceBalance: number | null = null;
    RepeatDetails: RepeatDetailsItem | null = null;
    DateOffset: number = 0;
    DueDateOffset: number | null = null;
    InvoiceMode: InvoiceMode = InvoiceMode.Prepaid;
    InvoiceFormat: InvoiceFormat = InvoiceFormat.Expanded;
    GenerateZeroAmountInvoices: boolean = false;
    IncludeBalanceForwardOnInvoices: boolean = false;
    AutoInvoiceFooter: string | null = null;

    constructor(initializer?: Partial<AutoInvoiceDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AutoInvoiceDisplayItem";
}
